import getCharts from '../getCharts'
import { PatientMapCRUD } from '../../constants/api.config'

export default async function ModifyPatientMap(mode="GET", patientID, diagnosis="", facilityID="-1" ) {
 
  try {
    const payload = {patientID, diagnosis, facilityID, mode }
    const res = await getCharts(PatientMapCRUD, payload)
    return res.data
  } catch (error) {
    return error
  }
}
